// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageContainerStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

pageContainerStyles.loadingOverlay = {
    css: css`
        width: 100%;
    `,
};

pageContainerStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};

pageContainerStyles.productListGridItemWide = {
    css: css`
        width: 100%;
    `,
};

pageContainerStyles.paymentDetailsGridItem = {
    css: css`
        width: 100%;
        display: grid;
        grid-template-columns: 300px 1fr;
        grid-template-rows: auto;
        grid-column-gap: 135px;
        grid-row-gap: 24px;
        grid-template-areas: "shippingMethod paymentSection";
        ${({ hasMultiplePaymentMethods }: any) => {
            const styles = css`
                grid-template-areas:
                    "shippingMethod shippingMethod"
                    "paymentSection paymentSection";
            `;
            if (hasMultiplePaymentMethods) {
                return css`
                    ${xScreen("lte", 1300)} {
                        ${styles}
                    }
                `;
            }
            return css`
                ${xScreen("lte", "md")} {
                    ${styles}
                }
            `;
        }}

        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
            grid-template-areas:
                "shippingMethod"
                "paymentSection";
        }
        & .shippingMethod {
            grid-area: shippingMethod;
            ${({ hasMultiplePaymentMethods }: any) => {
                const styles = css`
                    padding-bottom: 24px;
                    border-bottom: 1px solid ${color("common.ui3")};
                `;
                if (hasMultiplePaymentMethods) {
                    return css`
                        ${xScreen("lte", 1300)} {
                            ${styles}
                        }
                    `;
                }
                return css`
                    ${xScreen("lte", "md")} {
                        ${styles}
                    }
                `;
            }}
        }
        & .paymentSection {
            grid-area: paymentSection;
        }
    `,
};

pageContainerStyles.shippingInfoGridItemNarrow = {
    css: css`
        width: 100%;
        padding-bottom: 24px;
        border-bottom: 1px solid ${color("common.ui3")};
    `,
};
